/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAssessment = /* GraphQL */ `
  mutation CreateAssessment(
    $input: CreateAssessmentInput!
    $condition: ModelAssessmentConditionInput
  ) {
    createAssessment(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      siteInfo {
        organizationName
        siteType
        region
        annualVolume
        __typename
      }
      responseTimes {
        averageResponse
        simpleStudies
        complexStudies
        rushRequests
        __typename
      }
      staffResources {
        dedicatedFTE
        experienceLevel
        currentTools
        peakCapacity
        __typename
      }
      studyPortfolio {
        therapeuticAreas
        studyPhases
        internationalPercentage
        enrollmentTargets
        __typename
      }
      processAssessment {
        documentationProcess
        approvalStages
        commonDelays
        __typename
      }
      contactInfo {
        name
        email
        phone
        organization
        bestTimeToContact
        interests
        __typename
      }
      calculatedResults {
        total
        speed
        efficiency
        quality
        growth
        percentile
        __typename
      }
      __typename
    }
  }
`;
export const updateAssessment = /* GraphQL */ `
  mutation UpdateAssessment(
    $input: UpdateAssessmentInput!
    $condition: ModelAssessmentConditionInput
  ) {
    updateAssessment(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      siteInfo {
        organizationName
        siteType
        region
        annualVolume
        __typename
      }
      responseTimes {
        averageResponse
        simpleStudies
        complexStudies
        rushRequests
        __typename
      }
      staffResources {
        dedicatedFTE
        experienceLevel
        currentTools
        peakCapacity
        __typename
      }
      studyPortfolio {
        therapeuticAreas
        studyPhases
        internationalPercentage
        enrollmentTargets
        __typename
      }
      processAssessment {
        documentationProcess
        approvalStages
        commonDelays
        __typename
      }
      contactInfo {
        name
        email
        phone
        organization
        bestTimeToContact
        interests
        __typename
      }
      calculatedResults {
        total
        speed
        efficiency
        quality
        growth
        percentile
        __typename
      }
      __typename
    }
  }
`;
export const deleteAssessment = /* GraphQL */ `
  mutation DeleteAssessment(
    $input: DeleteAssessmentInput!
    $condition: ModelAssessmentConditionInput
  ) {
    deleteAssessment(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      siteInfo {
        organizationName
        siteType
        region
        annualVolume
        __typename
      }
      responseTimes {
        averageResponse
        simpleStudies
        complexStudies
        rushRequests
        __typename
      }
      staffResources {
        dedicatedFTE
        experienceLevel
        currentTools
        peakCapacity
        __typename
      }
      studyPortfolio {
        therapeuticAreas
        studyPhases
        internationalPercentage
        enrollmentTargets
        __typename
      }
      processAssessment {
        documentationProcess
        approvalStages
        commonDelays
        __typename
      }
      contactInfo {
        name
        email
        phone
        organization
        bestTimeToContact
        interests
        __typename
      }
      calculatedResults {
        total
        speed
        efficiency
        quality
        growth
        percentile
        __typename
      }
      __typename
    }
  }
`;
